import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LinkButton = styled(Typography)(() => ({
  fontSize: "0.8rem",
  cursor: "pointer",
  color: "#5783F1",
  textDecoration: "underline",
}));
